export const THREAD_Z_INDEX = 1071; // more than tooltip zIndex
